import { useEffect, useRef, useState, CSSProperties } from 'react'
import DataTable from '../components/DataTable';
import { KTSVG } from '../../_metronic/helpers'
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import { getRequestOptions } from '../helpers/Fetchwrapper';
import Select from 'react-select';
import AdvancePaymentAdjustmentModal from '../components/AdvancePaymentAdjustmentModal';
import ComplianceInvoiceModal from '../components/ComplianceInvoiceModal';
import Swal from 'sweetalert2';

function InvoiceRowActions({ row, onAdjust, onCompliance }: { row: any; onAdjust: (idSalesInvoice: number) => void; onCompliance: (idSalesInvoice: number) => void }) {
    const [open, setOpen] = useState(false)
    const [menuStyle, setMenuStyle] = useState<CSSProperties>({ display: 'none' })
    const containerRef = useRef<HTMLDivElement>(null)
    const buttonRef = useRef<HTMLButtonElement>(null)

    const updateMenuPosition = () => {
        if (!buttonRef.current) {
            return
        }

        const rect = buttonRef.current.getBoundingClientRect()
        setMenuStyle({
            position: 'fixed',
            top: `${rect.bottom + 2}px`,
            left: `${rect.right}px`,
            transform: 'translateX(-100%)',
            minWidth: 'max-content',
            width: 'auto',
            whiteSpace: 'nowrap',
            zIndex: 1050,
            display: 'block',
        })
    }

    useEffect(() => {
        if (!open) {
            setMenuStyle({ display: 'none' })
            return
        }

        updateMenuPosition()

        const handleClickOutside = (event: MouseEvent) => {
            if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
                setOpen(false)
            }
        }

        const handleReposition = () => setOpen(false)

        document.addEventListener('mousedown', handleClickOutside)
        window.addEventListener('scroll', handleReposition, true)
        window.addEventListener('resize', handleReposition)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
            window.removeEventListener('scroll', handleReposition, true)
            window.removeEventListener('resize', handleReposition)
        }
    }, [open])

    const closeMenu = () => setOpen(false)

    return (
        <div ref={containerRef} className="d-flex justify-content-center">
            <button
                ref={buttonRef}
                className="btn btn-light-primary btn-sm dropdown-toggle"
                type="button"
                aria-expanded={open}
                onClick={(e) => {
                    e.stopPropagation()
                    setOpen((prev) => !prev)
                }}
            >
                Action
            </button>
            <div className="dropdown-menu dropdown-menu-end show" style={menuStyle}>
                <button
                    type="button"
                    className="dropdown-item d-flex align-items-center text-nowrap"
                    onClick={() => {
                        closeMenu()
                        onAdjust(row.id)
                    }}
                >
                    <KTSVG
                        path='/media/svg/icons/Design/Crop.svg'
                        className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                    />
                    Adjustment
                </button>
                {row.hasComplianceInvoice === 'Yes' && (
                    <button
                        type="button"
                        className="dropdown-item d-flex align-items-center text-nowrap"
                        onClick={() => {
                            closeMenu()
                            onCompliance(row.id)
                        }}
                    >
                        <KTSVG
                            path='/media/svg/icons/Devices/Printer.svg'
                            className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                        />
                        Compliance Invoice
                    </button>
                )}
                {row.salesType === 'Inter Business Unit' && (
                    <Link
                        className="dropdown-item d-flex align-items-center text-nowrap"
                        to={`/sales-invoice-inter-bu/${row.id}`}
                        onClick={closeMenu}
                    >
                        <KTSVG
                            path='/media/svg/icons/Devices/Printer.svg'
                            className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                        />
                        New Inter BU Invoice
                    </Link>
                )}
                <a
                    className="dropdown-item d-flex align-items-center text-nowrap"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${process.env.REACT_APP_BACKEND}invoiceDownload/${row.id}`}
                    onClick={closeMenu}
                >
                    <KTSVG
                        path='/media/svg/icons/Devices/Printer.svg'
                        className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                    />
                    Invoice
                </a>
                <a
                    className="dropdown-item d-flex align-items-center text-nowrap"
                    target="_blank"
                    rel="noopener noreferrer"
                    href={`${process.env.REACT_APP_BACKEND}invoiceView/${row.id}`}
                    onClick={closeMenu}
                >
                    <KTSVG
                        path='/media/svg/icons/General/Visible.svg'
                        className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                    />
                    Invoice View
                </a>
                {row.doublePrint === 'Yes' && (
                    <a
                        className="dropdown-item d-flex align-items-center text-nowrap"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`${process.env.REACT_APP_BACKEND}invoiceDownload/${row.id}?withoutBackground=1`}
                        onClick={closeMenu}
                    >
                        <KTSVG
                            path='/media/svg/icons/Devices/Printer.svg'
                            className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                        />
                        Invoice without Background
                    </a>
                )}
                <Link
                    className="dropdown-item d-flex align-items-center text-nowrap"
                    to={`sales-invoice/${row.id}`}
                    onClick={closeMenu}
                >
                    <KTSVG
                        path='/media/svg/icons/Layout/Layout-grid.svg'
                        className='svg-icon-5 svg-icon me-2 flex-shrink-0'
                    />
                    Details
                </Link>
            </div>
        </div>
    )
}

function SalesInvoice() {


    const hasPermission = 1; //parseInt(GetPagePermission("/setup-company-list"));

    const [selectProjectOptions, setSelectProjectOptions] = useState([])
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [newData, setNewData] = useState({});
    const [showAdvanceAdjustmentModal, setShowAdvanceAdjustmentModal] = useState(false);
    const [complianceInvoiceId, setComplianceInvoiceId] = useState<number | null>(null);
    const [adjustmentModalData, setAdjustmentModalData] = useState<{
        idSalesInvoice: number;
        idCompanies: number;
        idProjects: number;
        maxAdjustableAmount: number;
        totalInvoiceAmount: number;
        vatAmount: number;
        discountAmount: number;
    } | null>(null);

    const makeAdjustment = (idSalesInvoice: number) => {
        fetch(process.env.REACT_APP_API_URL + 'sales-invoice/adjustment/' + idSalesInvoice, getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                const inv = resp.data;
                const so = inv?.sales_order ?? inv?.salesOrder;
                const idCompanies = (so?.id_companies ?? so?.idCompanies) ?? 0;
                const idProjects = (so?.id_projects ?? so?.idProjects) ?? 0;
                const invoiceAmount = parseFloat(inv?.invoice_amount ?? inv?.invoiceAmount ?? 0);
                setAdjustmentModalData({
                    idSalesInvoice,
                    idCompanies,
                    idProjects,
                    maxAdjustableAmount: resp.maxAdjustableAmount ?? 0,
                    totalInvoiceAmount: invoiceAmount,
                    vatAmount: 0,
                    discountAmount: 0,
                });
                setShowAdvanceAdjustmentModal(true);
            })
            .catch((error) => {
                console.log(error, 'adjustment fetch');
                Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to load adjustment data.' });
            });
    }

    const handleAdvanceAdjustmentClose = () => {
        setShowAdvanceAdjustmentModal(false);
        setAdjustmentModalData(null);
    }

    const handleProjectChange = (project: any) => {
        setProject(project);
    }

    const getProjectList = async () => {
        const url = process.env.REACT_APP_API_URL + 'projects';
        const response = await fetch(url, getRequestOptions());
        const data = await response.json();
        data.data.map((element: any) => {
            element.value = element.id_projects;
            element.label = element.project_name;
            return element;
        })

        if (data.data.length === 1) {
            setSelectProjectOptions(data.data)
        } else {
            var allProjectsOpt = [{ id: '', name: '', label: 'All Project', value: '' }]
            let allProjects = data.data.concat(allProjectsOpt);
            setSelectProjectOptions(allProjects);
        }

    }

    const numberFormat = (value: any) => {

        value = parseFloat(value)
        if (typeof (value) !== 'number') {
            return value;
        }
        return parseFloat(value.toString()).toLocaleString('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    useEffect(() => {
        getProjectList();
    }, [])

    useEffect(() => {
        if (selectProjectOptions.length === 1) {
            setProject({ label: selectProjectOptions[0]['label'], value: selectProjectOptions[0]['value'] })
        }
    }, [selectProjectOptions])

    useEffect(() => {
        setAdditionalPostData({ idProjects: project.value })
    }, [project])

    const [additionalPostData, setAdditionalPostData] = useState({ idProjects: '' });

    const columns = [
        { value: 'id', title: 'ID', style: { textAlign: 'center' } },
        { value: 'invoiceId', title: 'Invoice ID', style: { textAlign: 'center' } },
        { value: 'referenceNo', title: 'Reference No.', style: { textAlign: 'center' } },
        { value: 'idSalesOrders', title: 'Sales Order ID', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Project', style: { textAlign: 'center' } },
        { value: 'companyName', title: 'Client', style: { textAlign: 'center' } },
        { value: 'invoiceDate', title: 'Invoice Date', style: { textAlign: 'center' } },
        { value: 'creditDays', title: 'Credit Days', style: { textAlign: 'center' } },
        {
            value: 'overDueDate', title: 'Over Due Date', style: { textAlign: 'center' },
        },
        {
            value: 'invoiceAmount', title: 'Invoice Amount', style: { textAlign: 'center', whiteSpace: 'nowrap' }, hasHtmlComponent: true, htmlComponent: ((row: any) => {
                const currentDate = new Date();
                const overDueDate = new Date(row.overDueDate);
                const isDanger = row.dueAmount > 0 && overDueDate < currentDate;
                
                return (
                    <span 
                        className={isDanger ? 'text-danger fw-bold' : ''} 
                        title={`Due Amount: ${numberFormat(row.dueAmount)}`}
                        style={{ cursor: 'help' }}
                    >
                        {numberFormat(row.invoiceAmount)}
                    </span>
                )
            }),
        },
        {
            value: 'advanceAdjustment', title: 'Adjustment', style: { textAlign: 'center', whiteSpace: 'nowrap' }, hasHtmlComponent: true, htmlComponent: ((row: any) => {
                return numberFormat(row.advanceAdjustment)
            }),
        },
        { value: 'shipments', title: 'Shipments', style: { textAlign: 'center' } },
        { value: 'salesOrderReturns', title: 'Returns', style: { textAlign: 'center' } },
        { value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
        {
            value: 'action', title: 'Action', style: { textAlign: 'center' }, hasActionsComponent: true, actionsComponent: ((row: any) => {
                return <InvoiceRowActions row={row} onAdjust={makeAdjustment} onCompliance={setComplianceInvoiceId} />
            })
        }
    ]

    const filters = {
        id: {
            filterType: 'like',
            filterValue: '',
        },
        invoiceId: {
            filterType: 'like',
            filterValue: '',
        },
        referenceNo: {
            filterType: 'like',
            filterValue: '',
        },
        idSalesOrders: {
            filterType: 'like',
            filterValue: '',
        },
        projectName: {
            filterType: 'like',
            filterValue: '',
        },
        companyName: {
            filterType: 'like',
            filterValue: '',
        },
        invoiceDate: {
            filterType: 'like',
            filterValue: '',
        },
        overDueDate: {
            filterType: 'like',
            filterValue: '',
        },
        creditDays: {
            filterType: 'like',
            filterValue: '',
        },
        invoiceAmount: {
            filterType: 'like',
            filterValue: '',
        },
        advanceAdjustment: {
            filterType: 'like',
            filterValue: '',
        },
        // receivedAmount: {
        //     filterType: 'like',
        //     filterValue: '',
        // },
        // dueAmount: {
        //     filterType: 'like',
        //     filterValue: '',
        // },
        shipments: {
            filterType: 'like',
            filterValue: '',
        },
        salesOrderReturns: {
            filterType: 'like',
            filterValue: '',
        },
        createdBy: {
            filterType: 'like',
            filterValue: '',
        },
    }

    const url = process.env.REACT_APP_API_URL + 'sales-invoice/dt'

    return (
        <>
            {hasPermission === 1 &&
                <>
                    <div className='card card-custom'>
                        <div className='card-header'>
                            <div className="card-title">
                                <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                                <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                    Sales Invoices
                                </span>
                            </div>
                            <div className="card-toolbar">
                                <div className='d-flex justify-content-end'>
                                    <Select
                                        // defaultValue={selectProjectOptions}
                                        onChange={handleProjectChange}
                                        options={selectProjectOptions}
                                        placeholder={project.label}
                                    />
                                    &nbsp;
                                    <Link to={`/sales-invoice-create`} className="btn btn-sm btn-primary"><i className="fa fa-plus"></i>Create New Sales Invoice</Link>
                                </div>
                            </div>
                        </div>

                        <div className='card-body'>
                            <DataTable url={url} columns={columns} filters={filters} additionalPostData={additionalPostData} newData={newData} />
                        </div>
                    </div >

                    {adjustmentModalData && (
                        <AdvancePaymentAdjustmentModal
                            show={showAdvanceAdjustmentModal}
                            onClose={handleAdvanceAdjustmentClose}
                            idCompanies={adjustmentModalData.idCompanies}
                            idProjects={adjustmentModalData.idProjects}
                            maxAdjustableAmount={adjustmentModalData.maxAdjustableAmount}
                            totalInvoiceAmount={adjustmentModalData.totalInvoiceAmount}
                            vatAmount={adjustmentModalData.vatAmount}
                            discountAmount={adjustmentModalData.discountAmount}
                            idSalesInvoice={adjustmentModalData.idSalesInvoice}
                            onSuccess={() => setNewData({ id: Date.now() })}
                        />
                    )}
                    <ComplianceInvoiceModal
                        show={complianceInvoiceId !== null}
                        invoiceId={complianceInvoiceId}
                        onClose={() => setComplianceInvoiceId(null)}
                    />

                </>
            }


            {/* {hasPermission === 0 &&
                <Error />
            }
            {hasPermission === 0 &&
                <div className='card card-custom' style={{ padding: "15px" }} >
                    <SkeletonTheme>
                        <p>
                            <Skeleton
                                containerClassName="avatar-skeleton"
                                count={40} ></Skeleton>
                        </p>
                    </SkeletonTheme>
                </div>
            } */}

        </>
    )
}

export default SalesInvoice
